// extracted by mini-css-extract-plugin
export default {"f":"_93d0023e06","main":"_8a199c2767","btn":"_60e503ecb5","w":"_59bf02c0be","h":"d50c4d99f6","lh25":"_6c1b915723","wb":"_627abb04ac","b":"_79e3246640","bx":"d406b8989f"};